import React, { useState, useEffect } from "react";
import {
  writeTransactionFromWallet,
  readTransactionFromWallet,
  getEnrollmentIdFromWallet,
} from "../extensionMethods/app";
// import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import { Button, TextField, Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import config from "../config";
import { DAPP_ICON, TransactionName } from "../constants";
import ConfirmModal from "./ConfirmPopup";
import {
  ExecuteReadTransaction,
  ExecuteSubmitTransaction,
  formattedErrorMessage,
} from "../utils";
import dayjs from "dayjs";
import MyVerticallyCenteredModal from "./MyVerticallyCenteredModal";
import BigNumber from "bignumber.js";

const getErrorMessage = (message) => {
  try {
    // Remove "Error:" prefix if it exists
    if (message.startsWith("Error:")) {
      message = message.replace("Error: ", "");
    }

    // Try to parse as JSON first (for structured errors)
    if (message.startsWith("{")) {
      const parsedError = JSON.parse(message);

      // Check for specific error message and return custom messages
      if (parsedError?.message?.error === "insufficient balance") {
        return "Not Authorized!";
      }

      // Return the error message from the parsed object if available
      return parsedError.message?.error || "Unknown Error";
    }

    // Handle plain text errors
    if (message === "insufficient balance") {
      return "Not Authorized!";
    }

    // If no mapping, return the original message
    return message;
  } catch (err) {
    // If parsing fails, return the original message or a fallback
    return message || "An unexpected error occurred.";
  }
};

const LockRedeem = ({ balance, setBalance, isConnected, walletConnected }) => {
  var dappToken = "";
  const [receiverAddress, setReceiverAddress] = useState("");
  console.log(receiverAddress, "re");
  const [amount, setAmount] = useState(new BigNumber(0));
  const [responseMessage, setResponseMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({}); // To store validation errors
  const [lockSelected, setLockSelected] = useState(true);
  const [selectedDate, setSelectedDate] = useState("");
  const [confirmPopupOpen, setConfirmPopupOpen] = useState(false);
  const [redeemableTokens, setRedeemableTokens] = useState(new BigNumber(0));
  const [approved, setApproved] = useState(false);
  const [loading, setLoading] = useState(false);
  const validationErrors = {};

  console.log(isConnected, receiverAddress?.length, "isConnected");

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (isConnected) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [isConnected]);

  const handleLock = async () => {
    setConfirmPopupOpen(false);
    // let validationErrors = {};

    // Validate amount
    if (
      !amount ||
      !new BigNumber(amount).isFinite() ||
      new BigNumber(amount).isLessThanOrEqualTo(0)
    ) {
      validationErrors.amount = "Amount must be a valid number greater than 0";
    }

    // Validate receiver address
    if (!receiverAddress) {
      validationErrors.receiverAddress = "Receiver's address is required";
    }
    // Validate selected date
    if (!selectedDate) {
      validationErrors.date = "Date must be selected";
    }

    // If there are errors, set the errors state and prevent transaction
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear any existing errors before proceeding
    setErrors({});

    setResponseMessage("");

    try {
      // Parse the date string
      const date = new Date(selectedDate);
      // Adjust for IST (UTC + 5:30)
      const utcDate = new Date(date.getTime() - 5.5 * 60 * 60 * 1000);

      const timeString = utcDate.toISOString(); // Convert to ISO UTC string
      const [res2, errMsg] = await ExecuteSubmitTransaction(
        config.CHANNEL_NAME,
        config.SUPPORT_CHAINCODE_NAME,
        TransactionName.LOCK,
        [
          receiverAddress,
          new BigNumber(amount).multipliedBy(100).toFixed(0),
          timeString,
        ]
      );
      if (res2 !== undefined) {
        setResponseMessage(`${res2}`);
        setReceiverAddress("");
        setSelectedDate("");
        setAmount(new BigNumber(0));
        setApproved(false);
        setBalance(new BigNumber(balance).minus(amount));
      } else {
        setResponseMessage(
          `Error: ${
            res2 !== undefined
              ? formattedErrorMessage(res2)
              : formattedErrorMessage(errMsg)
          }`
        );
      }
    } catch (err) {
      console.log(err);
      setResponseMessage(`Error: ${formattedErrorMessage(err)}`);
    } finally {
      setModalShow(true);
    }
  };

  const handleAmountError = () => {
    if (amount === "") {
      setAmount(new BigNumber(0).toFixed());
    } else {
      setAmount(new BigNumber(amount).toFixed());
    }
    if (!amount || new BigNumber(amount).isLessThanOrEqualTo(0)) {
      validationErrors.amount = "Amount must be greater than 0";
    } else if (new BigNumber(amount).isGreaterThan(new BigNumber(balance))) {
      validationErrors.amount = "Amount exceeds available balance";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setIsEditing(false);
  };
  const handleApprove = async () => {
    setConfirmPopupOpen(false);
    // let validationErrors = {};

    // Validate amount
    if (!amount || new BigNumber(amount).isLessThanOrEqualTo(0)) {
      validationErrors.amount = "Amount must be greater than 0";
    }

    // Validate receiver address
    if (!receiverAddress) {
      validationErrors.receiverAddress = "Receiver's address is required";
    }
    // Validate selected date
    if (!selectedDate) {
      validationErrors.date = "Date must be selected";
    }

    // If there are errors, set the errors state and prevent transaction
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear any existing errors before proceeding
    setErrors({});

    setResponseMessage("");

    try {
      const transactionParams = [
        config.SUPPORT_CHAINCODE_NAME,
        new BigNumber(amount).multipliedBy(100).toFixed(0),
      ];
      const [res, errMsg] = await ExecuteSubmitTransaction(
        config.CHANNEL_NAME,
        config.CHAINCODE_NAME,
        TransactionName.APPROVE,
        transactionParams
      );
      if (res) {
        setResponseMessage(`${res}`);
        setApproved(true);
        setReceiverAddress("");
        setSelectedDate("");
        setAmount(new BigNumber(0));
        setBalance(new BigNumber(balance).minus(amount));
      } else {
        setResponseMessage(
          `Error: ${
            res !== undefined
              ? formattedErrorMessage(res)
              : formattedErrorMessage(errMsg)
          }`
        );
      }
    } catch (err) {
      console.log(err);
      setResponseMessage(`Error: ${formattedErrorMessage(err)}`);
    } finally {
      setModalShow(true);
    }
  };
  const handleRedeem = async () => {
    setConfirmPopupOpen(false);
    setResponseMessage("");
    try {
      const [res, errMsg] = await ExecuteSubmitTransaction(
        config.CHANNEL_NAME,
        config.SUPPORT_CHAINCODE_NAME,
        TransactionName.REDEEM,
        []
      );
      if (res) {
        setResponseMessage(`${res}`);
        setRedeemableTokens(new BigNumber(0));
        setBalance(new BigNumber(balance).plus(redeemableTokens));
      } else {
        setResponseMessage(
          `Error: ${
            formattedErrorMessage(res.error) || formattedErrorMessage(errMsg)
          }`
        );
      }
    } catch (err) {
      console.log(err);
      setResponseMessage(`Error: ${formattedErrorMessage(err)}`);
    } finally {
      setModalShow(true);
    }
  };

  useEffect(() => {
    setErrors({});
  }, [lockSelected]);

  useEffect(() => {
    const fetchRedeemableTokens = async () => {
      try {
        console.log(`Fetching redeemable tokens`);
        const [res, errMsg] = await ExecuteReadTransaction(
          config.CHANNEL_NAME,
          config.SUPPORT_CHAINCODE_NAME,
          TransactionName.AVAILABLE_TOKENS, // Ensure the correct transaction name
          []
        );
        if (res) {
          console.log("Redeemable tokens response: ", typeof res, res);
          const jsonRes = JSON.parse(res);
          if (!Array.isArray(jsonRes)) {
            console.error(
              "Response from GetAvailableTokens is not an array",
              res
            );
          }

          // Calculate the sum of the Amount field
          const totalAmount = jsonRes.reduce((sum, item) => {
            // Ensure the item has a valid Amount and add it to the sum using BigNumber
            const amount = new BigNumber(item.Amount || 0); // Default to 0 if Amount is invalid
            return sum.plus(amount.div(100)); // Divide amount by 100 and add to sum
          }, new BigNumber(0)); // Initialize sum as a BigNumber
          setRedeemableTokens(totalAmount);
        } else {
          throw new Error(formattedErrorMessage(errMsg));
        }
      } catch (error) {
        console.error("Error fetching Redeemable Tokens:", error);
      }
    };
    setTimeout(() => {
      fetchRedeemableTokens();
    }, 2000);
  }, [walletConnected]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingBottom: "20px",
        textAlign: "center",
        backgroundColor: "#f2f4f6",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          paddingBottom: "20px",
        }}
      >
        {/* Lock Button */}
        <button
          onClick={() => setLockSelected(true)}
          style={{
            padding: "10px 20px",
            borderRadius: "10px",
            border: lockSelected ? "2px solid #0055FF" : "1px solid lightgray",
            backgroundColor: lockSelected ? "rgba(0, 85, 255, 0.1)" : "white",
            color: lockSelected ? "#0055FF" : "black",
            fontWeight: lockSelected ? "bold" : "normal",
            cursor: "pointer",
            outline: "none",
            width: "120px",
          }}
        >
          Lock
        </button>

        {/* Redeem Button */}
        <button
          onClick={() => setLockSelected(false)}
          style={{
            padding: "10px 20px",
            borderRadius: "10px",
            border: !lockSelected ? "2px solid #0055FF" : "1px solid lightgray",
            backgroundColor: !lockSelected ? "rgba(0, 85, 255, 0.1)" : "white",
            color: !lockSelected ? "#0055FF" : "black",
            fontWeight: !lockSelected ? "bold" : "normal",
            cursor: "pointer",
            outline: "none",
            width: "120px",
          }}
        >
          Redeem
        </button>
      </div>
      <Box
        sx={{
          padding: "20px",
          textAlign: "center",
          borderRadius: "10px",
          width: "100%", // This ensures it will align with the button width
          maxWidth: "600px", // Ensure it's aligned with the button width
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "#7A7A7A", marginBottom: "10px" }}
        >
          {lockSelected ? "Lock" : "Redeem"}
        </Typography>
        {/* Toggle between Typography and input */}
        {isEditing ? (
          <input
            value={amount}
            type="text"
            onChange={(e) => {
              const regex = /^\d{0,21}(\.\d{0,2})?$/;
              const value = e.target.value
                .replace(/[^0-9.]/g, "") // Remove non-numeric characters except "."
                .replace(/(\..*?)\..*/g, "$1") // Allow only one decimal point
                .replace(/^(\d+\.\d{2})\d+$/, "$1") // Limit to 2 decimal places
                .replace(/^0([0-9]+)/, "$1"); // Remove leading zeros
              if (regex.test(value)) {
                setAmount(value);
              }
            }}
            onBlur={handleAmountError}
            autoFocus
            style={{
              fontWeight: "bold",
              fontSize: "32px",
              textAlign: "center",
              marginBottom: "10px",
              color: "#9E9E9E",
              border: "none",
              outline: "none",
              appearance: "textfield", // Removes the number input arrows
              borderColor: errors.amount ? "red" : "", // Add red border on error
            }}
          />
        ) : (
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              color: "black",
              cursor: "pointer",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "clamp(12px, 5vw, 36px)",
              textAlign: "center",
              maxWidth: "100%",
            }}
            onBlur={handleAmountError}
            onClick={() => {
              if (lockSelected && !approved) setIsEditing(true);
            }} // Enter edit mode on click
          >
            ₹
            {lockSelected
              ? new BigNumber(amount).toFormat(2)
              : new BigNumber(redeemableTokens).toFormat(2)}
          </Typography>
        )}
        {new BigNumber(amount).isLessThanOrEqualTo(0) && errors.amount && (
          <Typography variant="body2" sx={{ color: "red" }}>
            {errors.amount}
          </Typography>
        )}{" "}
        {/* Show error */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >
          <img
            src={DAPP_ICON} // Replace with actual CBDC image
            alt="CBDC Icon"
            style={{ width: "20px", height: "20px", marginRight: "5px" }}
          />
          <Typography variant="body1" sx={{ color: "#7A7A7A" }}>
            CBDC
          </Typography>
        </Box>
        {lockSelected ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <Button
              variant="outlined"
              disabled={!isConnected}
              sx={{
                borderRadius: "10px",
                minWidth: "60px",
                marginRight: "10px",
                color: "#4C2CF5",
                borderColor: "#4C2CF5",
                marginBottom: "-10px",
                "&:hover": { backgroundColor: "#F0F0F0" },
              }}
              onClick={() => {
                if (!approved) {
                  setAmount(100) && handleAmountError();
                }
              }}
            >
              ₹100
            </Button>
            <Button
              variant="outlined"
              disabled={!isConnected}
              sx={{
                borderRadius: "10px",
                minWidth: "60px",
                marginRight: "10px",
                color: "#4C2CF5",
                borderColor: "#4C2CF5",
                marginBottom: "-10px",
                "&:hover": { backgroundColor: "#F0F0F0" },
              }}
              onClick={() => {
                if (!approved) {
                  setAmount(250) && handleAmountError();
                }
              }}
            >
              ₹250
            </Button>
            <Button
              variant="outlined"
              disabled={!isConnected}
              sx={{
                borderRadius: "10px",
                minWidth: "60px",
                color: "#4C2CF5",
                borderColor: "#4C2CF5",
                marginBottom: "-10px",
                "&:hover": { backgroundColor: "#F0F0F0" },
              }}
              onClick={() => {
                if (!approved) {
                  setAmount(500) && handleAmountError();
                }
              }}
            >
              ₹500
            </Button>
          </Box>
        ) : (
          ""
        )}
      </Box>
      {lockSelected ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontFamily: "Arial, sans-serif",
            width: "600px",
            margin: isConnected ? "0px" : "10px",
          }}
        >
          <label
            htmlFor="lockInDate"
            style={{
              fontSize: "14px",
              marginTop: "8px",
              textAlign: "left",
            }}
          >
            Lock-In Till
          </label>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <input
              type="date"
              id="lockInDate"
              value={selectedDate}
              onChange={handleDateChange}
              style={{
                padding: "8px",
                fontSize: "16px",
                border: "1px solid #ccc",
                color: "#888",
                borderRadius: "8px",
                flexGrow: 1,
                height: "50px",
              }}
              readOnly={approved}
              min={dayjs().add(1, "day").format("YYYY-MM-DD")} // Prevent past dates
            />
          </div>
          {errors.date && (
            <Typography variant="body2" sx={{ color: "red" }}>
              {errors.date}
            </Typography>
          )}{" "}
          {/* Show error */}
        </div>
      ) : (
        ""
      )}
      {isConnected && (
        <Box
          sx={{
            margin: "10px 0px",
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="body2">Balance:</Typography>
          <Typography
            variant="body2"
            sx={{ color: "#0033cc", fontWeight: "bold" }}
          >
            {loading
              ? "Loading"
              : !loading &&
                isConnected &&
                !isNaN(Number(balance)) &&
                Number(balance) > 0
              ? `₹${new BigNumber(balance).toFormat(2)}`
              : `₹0.00`}
          </Typography>
        </Box>
      )}
      {lockSelected ? (
        <TextField
          placeholder="Enter Receiver's Address"
          value={receiverAddress}
          onChange={(e) => setReceiverAddress(e.target.value.toLowerCase())}
          variant="outlined"
          fullWidth
          sx={{
            textTransform: "lowercase",
            backgroundColor: "white",
            borderRadius: "8px",
            marginBottom: "20px",
            maxWidth: "600px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "& fieldset": {
                borderColor: errors.receiverAddress ? "red" : "#E0E0E0", // Add red border on error,
              },
              "&:hover fieldset": {
                borderColor: errors.receiverAddress ? "red" : "#E0E0E0",
              },
              "&.Mui-focused fieldset": {
                borderColor: errors.receiverAddress ? "red" : "#1976D2",
              },
            },
          }}
          InputProps={{
            readOnly: approved,
          }}
        />
      ) : (
        ""
      )}
      {errors.receiverAddress && (
        <Typography variant="body2" sx={{ color: "red" }}>
          {errors.receiverAddress}
        </Typography>
      )}{" "}
      {/* Show error */}
      <Button
        variant="contained"
        disabled={
          (!lockSelected
            ? Number(redeemableTokens) === 0
            : Number(amount) === 0 ||
              new BigNumber(amount).isGreaterThan(new BigNumber(balance)) ||
              receiverAddress?.length != 40 ||
              selectedDate == "") || !isConnected
        }
        fullWidth
        onClick={() => {
          setConfirmPopupOpen(true);
        }}
        sx={{
          backgroundColor: "#0055FF",
          borderRadius: "8px",
          height: "45px",
          maxWidth: "600px", // Ensure this width matches the box width
          textTransform: "none",
          fontSize: "16px",
          fontWeight: "bold",
          marginTop: "20px",
          "&:hover": {
            backgroundColor: "#0044CC",
          },
        }}
      >
        {!lockSelected ? "Redeem" : approved ? "Lock" : "Approve"}
      </Button>
      <ConfirmModal
        open={confirmPopupOpen}
        setOpen={setConfirmPopupOpen}
        onConfirm={
          !lockSelected ? handleRedeem : approved ? handleLock : handleApprove
        }
      />
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message={responseMessage}
        getErrorMessage={getErrorMessage}
      />
    </Box>
  );
};

export default LockRedeem;
